<template>
	<article class="page" data-page="register-ranking">
		<ManagingSection>
			<ManagingBox title="랭킹타입">
				<RadioList
					v-model="period"
					:radioList="[
						{ id: 'this_week', value: '주간랭킹' },
						{ id: 'last_week', value: '지난주랭킹' },
						{ id: 'all', value: '누적랭킹' },
					]"
				/>
			</ManagingBox>
			<ManagingBox title="회원항번">
				<input
					type="text"
					placeholder="회원항번 검색"
					v-model="idRegister"
					@keyup.enter="onEnter"
				/>
			</ManagingBox>
		</ManagingSection>
		<div class="btn-wrap-main">
			<button class="btn-main blue" @click="onSearch">검색하기</button>
			<button class="btn-main blue bordered" @click="onReset">
				다시작성
			</button>
		</div>
		<hr class="section__divider" />
		<ManagingSection :isTable="true">
			<template slot="infoSection">
				<span class="section__info__left"
					>랭킹 회원수 : {{ this.hasList ? total : 0 }}명</span
				>
				<div class="section__info__right">
					<select-box
						@changing="onChangeLimit"
						:options="limitOpts"
						:val="limit"
						:addClass="'form-m'"
					/>
				</div>
			</template>
			<table class="table-main">
				<thead>
					<tr>
						<th>순위</th>
						<th>회원항번</th>
						<th>닉네임</th>
						<th>랭킹 점수</th>
					</tr>
				</thead>
				<tbody>
					<tr
						v-for="(item, idx) in userList"
						:data-idx="idx"
						:key="item"
					>
						<td>{{ item.rank }}</td>
						<td>{{ item.id }}</td>
						<td>
							<a
								class="link"
								:href="`/register/update_register?id=${item.id}&page=1&sort=1`"
								>{{ item.nickname }}</a
							>
						</td>
						<td>{{ item.score }}</td>
					</tr>
				</tbody>
			</table>
			<div class="empty-list" v-if="!hasList">
				<span>검색 결과가 없습니다.</span>
			</div>
			<pagination-box
				v-else
				slot="pagination"
				:totalItem="total"
				:offset="cursor"
				:limit="limit"
				:pageLengPerOne="pageGroupLimit"
				@to="paging"
			/>
		</ManagingSection>
	</article>
</template>

<script>
	import ManagingSection from '@/components/layout/ManagingSection.vue';
	import ManagingBox from '@/components/layout/ManagingBox.vue';
	import PaginationBox from '@/components/PaginationBox.vue';
	import SelectBox from '@/components/SelectBox.vue';
	//import { mapState, mapActions, mapMutations } from 'vuex';
	import RadioList from '@/components/RadioList';

	export default {
		name: 'ranking',
		data() {
			return {
				hasList: false,
				cursor: 1,
				limit: 20,
				period: 'this_week',
				idRegister: '',
				total: 0,
				userList: [],
				limitOpts: [
					{ id: 10, text: '10명씩' },
					{ id: 20, text: '20명씩' },
					{ id: 30, text: '30명씩' },
					{ id: 40, text: '40명씩' },
					{ id: 50, text: '50명씩' },
				],
				searchHistory: null,
				//
				pageSize: 0,
				pageGroupLimit: 10,
				pageGroupSize: 0,
				pageGroupTotalSize: 0,
				currentPageGroup: 1,
			};
		},
		computed: {
			/*userList: {
                set(v){
                    this._userList = v;
                },
                get(){
                    return this._userList || [];
                }
            }*/
		},
		created() {
			this.onSearch();
		},
		methods: {
			initPaging() {
				this.cursor = 1;
				this.pageSize = 0;
				this.pageGroupSize = 0;
				this.pageGroupTotalSize = 0;
				this.currentPageGroup = 1;
			},
			onEnter() {
				if (
					this.idRegister.replace(/\s/g, '').length === 0 ||
					Number.isNaN(Number(this.idRegister))
				) {
					alert('검색어가 없가나 올바르지 않습니다.');
				} else {
					this.onSearch();
				}
			},
			async onSearch(e) {
				this.hasList = true;
				this.$store.commit('toggleSpinner', true);
				this.oldCursor = this.cursor;
				//
				try {
					let params, res, data;
					if (this.idRegister.replace(/\s/g, '').length < 1) {
						if (this.searchHistory !== null) {
							if (
								this.searchHistory.period !== this.period ||
								this.searchHistory.limit !== this.limit
							) {
								this.initPaging();
							}
						}
						params = {
							cursor: this.cursor,
							limit: this.limit,
							period: this.period,
						};
						res = await this.$axios.get(
							`/lambda/admin/register/rank/list`,
							{ params }
						);
					} else {
						this.cursor = 1;
						params = {
							period: this.period,
						};
						res = await this.$axios.get(
							`/lambda/admin/register/rank/list/${this.idRegister}`,
							{ params }
						);
					}
					//
					data = res.data;
					this.searchHistory = {
						cursor: params.cursor || this.cursor,
						limit: params.limit || this.limit,
						period: params.period || this.period,
					};
					this.userList = data.userList;
					this.total = data.totalSize;
					//

					if (this.total > 0) {
						this.pageSize = Math.ceil(
							this.total / this.searchHistory.limit
						);
						this.pageGroupTotalSize = Math.ceil(
							this.pageSize / this.pageGroupLimit
						);
						this.currentPageGroup = Math.ceil(
							this.cursor / this.pageGroupLimit
						);

						if (this.pageGroupTotalSize === this.currentPageGroup) {
							this.pageGroupSize =
								this.pageSize % this.pageGroupLimit;
						} else {
							this.pageGroupSize = this.pageGroupLimit;
						}
						this.hasList = true;
					} else {
						this.hasList = false;
					}
				} catch (err) {
					this.hasList = false;
					this.userList = [];
				} finally {
					this.$store.commit('toggleSpinner', false);
				}
				/*if(this.idRegister.replace(/\s/g, '').length < 1) {
                    this.oldCursor = this.cursor;
                    try{
                        if( this.searchHistory !== null ){
                            if( this.searchHistory.period !== this.period || this.searchHistory.limit !== this.limit ){
                                this.initPaging();
                            }
                        }
                        const params = {
                            cursor: this.cursor,
                            limit: this.limit,
                            period: this.period
                        }
                        const {data} = await this.$axios.get( `/lambda/admin/register/rank/list`, {params} );
                        this.searchHistory = params;
                        this.userList = data.userList;
                        this.total = data.totalSize;
                        
                        if( this.total > 0 ){
                            this.pageSize = Math.ceil(this.total / this.searchHistory.limit);
                            this.pageGroupTotalSize = Math.ceil( this.pageSize / this.pageGroupLimit );
                            this.currentPageGroup = Math.ceil(this.cursor / this.pageGroupLimit);
                            if( this.pageGroupTotalSize === this.currentPageGroup ){
                                this.pageGroupSize = this.pageSize %  this.pageGroupLimit
                            }else{
                                this.pageGroupSize = this.pageGroupLimit;
                            }
                            this.hasList = true;
                        }else {
                            this.hasList = false;
                        }
                    }catch(err){
                        this.hasList = false;
                        this.userList = [];
                    }finally {
                        this.$store.commit('toggleSpinner', false);
                    }
                }else{
                    try{
                        const {data} = await this.$axios.get( `/lambda/admin/register/rank/list/${this.idRegister}?period=${this.period}` );
                        this.userList = data.userList;
                        this.total = data.totalSize;
                        if( this.total > 0 ) {
                            this.pageSize = Math.ceil(this.total / this.searchHistory.limit);
                            this.pageGroupTotalSize = Math.ceil( this.pageSize / this.pageGroupLimit );
                            this.currentPageGroup = Math.ceil(this.cursor / this.pageGroupLimit);
                            if( this.pageGroupTotalSize === this.currentPageGroup ){
                                this.pageGroupSize = this.pageSize %  this.pageGroupLimit
                            }else{
                                this.pageGroupSize = this.pageGroupLimit;
                            }
                            this.hasList = true;
                        }else{
                            this.hasList = false;
                        }
                    }catch(err){
                        this.userList = [];
                        this.hasList = false;
                    }finally {
                        this.$store.commit('toggleSpinner', false);
                    }
                }*/
			},
			onReset(e) {
				this.idRegister = '';
			},
			onChangeLimit(id) {
				this.limit = id;
			},
			// onPrev(){
			//     let cnt = this.currentPageGroup - 1;
			//     this.cursor = (cnt * this.pageGroupLimit);

			//     this.onSearch();
			// },
			// onNext(){
			//     let cnt = this.currentPageGroup + 1;
			//     this.cursor = ((cnt-1) * this.pageGroupLimit)+1;

			//     this.onSearch();
			// },
			// onGotoPage(pageIdx){
			//     const idx = pageIdx + ((this.currentPageGroup-1) * this.pageGroupLimit);
			//     if( this.cursor !== idx ){
			//         this.cursor = idx;

			//         this.onSearch();
			//     }
			// },
			paging(args) {
				this.cursor = args.offset;
				this.onSearch();
			},
		},

		// TODO 로딩바를 원하는 시점에 사용해 주세요.
		mounted() {
			//            this.$axios.get('/push/list', { params })

			this.$store.commit('toggleSpinner', false);
		},

		components: {
			ManagingSection,
			ManagingBox,
			PaginationBox,
			SelectBox,
			RadioList,
		},
	};
</script>

<style lang="scss" rel="stylesheet/scss">
	body [data-page='register-ranking'] {
		.table-main {
			min-width: 768px;
			tr:hover .td-pushtext .text {
				color: $font-blue;
				font-weight: bold;
				text-decoration: underline;
			}
			.link {
				text-decoration: underline;
			}
		}
		.paging-manager {
			padding-top: 40px;
		}
		.empty-list {
			width: 100%;
			text-align: center;
			padding: 15px 0 !important;
		}
	}
	@media (max-width: 768px) {
		#page-manage {
			.table-info {
				.table-desc {
					float: none;
					display: block;
				}
			}
		}
	}
</style>
